import React, { useEffect, useRef, useState } from "react";
import { CalendlyExpert } from "../../../utils/api-objects/CalendlyExpert";

interface Props {
    expert: CalendlyExpert,
}

const MAX_CLAMP_LINES = 3;

const ExpertCard: React.FC<Props> = ({
    expert,
}) => {
    const [expanded, setExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const bioRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (bioRef.current) {
            setShowButton(bioRef.current.scrollHeight > bioRef.current.clientHeight);
        }
    }, [expert.data.bio]);

    return (
        <div className="w-full min-h-[180px] p-[10px] rounded-md border border-solid border-border bg-white flex flex-col justify-between">
            <div className="w-full flex flex-col md:flex-row items-start md:items-center gap-4">
                <div className="w-[93px] h-[93px] rounded-full border border-solid border-border flex items-center justify-center overflow-hidden flex-shrink-0">
                    <img
                        className="w-full h-full object-cover"
                        src={
                            expert.calendly_data?.calendly_user?.avatar_url
                                ? expert.calendly_data.calendly_user.avatar_url
                                : "https://via.placeholder.com/150"
                        }
                        alt={`Avatar of ${expert.data?.name ?? ""} ${expert.data?.family_name ?? ""}`}
                        loading="lazy"
                        decoding="async"
                    />
                </div>
                <div className="flex flex-col md:flex-row md:justify-between flex-1 min-w-0 w-full">
                    <div className="mb-3 md:mb-0">
                        <div className="font-semibold truncate">
                            {expert.data?.name ?? ""} {expert.data?.family_name ?? ""}
                        </div>
                        <div className="text-sm text-gray-500 truncate">
                            {expert.email ?? ""}
                        </div>
                    </div>
                    <div className="flex flex-col text-gray-500 text-sm">
                        <div className="truncate">
                            Ordine: {expert.data.professional_order}
                        </div>
                        <div className="truncate">
                            Numero: {expert.data.professional_order_number}
                        </div>
                        <div className="truncate">
                            Stato: {expert.data.professional_order_state}
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-wrap gap-2 mt-3">
                {
                    (expert.tags ?? []).map((tag) => (
                        <div key={tag} className="text-sm text-gray-500 truncate bg-gray-100 px-[10px] py-[5px] rounded-md">
                            {tag}
                        </div>
                    ))
                }
            </div>
            <div className="mt-3 relative">
                <div
                    ref={bioRef}
                    className={`text-gray-700 text-sm transition-all duration-300 ${expanded ? "" : "line-clamp-3"}`}
                >
                    {expert.data?.bio ?? ""}
                </div>
                {showButton && (
                    <button
                        className="mt-1 text-primary text-xs font-medium hover:underline focus:outline-none"
                        onClick={() => setExpanded((e) => !e)}
                    >
                        {expanded ? "Mostra meno" : "Mostra di più"}
                    </button>
                )}
            </div>
        </div>
    )
}

export default ExpertCard
